import api from "@/lib/api";

export const supportService = {
  createTicket: (payload) => api.post("/support/tickets", payload).then((r) => r.data.ticket),
  myTickets: () => api.get("/support/tickets").then((r) => r.data.tickets),
};
